import { render, staticRenderFns } from "./deductible.vue?vue&type=template&id=1d538f80&scoped=true"
import script from "./deductible.vue?vue&type=script&lang=ts"
export * from "./deductible.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d538f80",
  null
  
)

export default component.exports